export const guardSection = <T extends string>(value: string, sections: string[]): value is T => {
    return sections.includes(value)
}